import type { ConfigType } from '@plone/registry';
import updateBlocksConfig from './blocks';
import updateWidgetsConfig from './widgets';
import updateSettingsConfig from './settings';
import updateApiExpanders from './api-expanders';
import updateViewsConfig from './views';
import updateReducersConfig from './reducers';
import updateRoutesConfig from './routes';
import updateMiddlewareConfig from './express-middleware';

export const applyAddonConfig = (config: ConfigType) => {
  updateBlocksConfig(config);
  updateWidgetsConfig(config);
  updateSettingsConfig(config);
  updateApiExpanders(config);
  updateViewsConfig(config);
  updateReducersConfig(config);
  updateRoutesConfig(config);
  updateMiddlewareConfig(config);
  return config;
};

export default applyAddonConfig;
